
// export const myGetter = ( state ) => {
//  return state
// }

export const countriesList = state => state.countries
export const countriesSelectable = state => state.countriesSelectable
export const countriesPaginatedData = state => state.countriesPaginatedData
export const country = state => state.country
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData